import * as Utils from "./../_ws/utils";
import * as WsRequest from "./ws-requests";
import * as WsCommandEnum from './../_ws/WsCommandEnum';
import ClipboardJS from "clipboard";

window.paginationObj = {
    page: 0,
    producer: [],
    price_min: 0,
    price_max: 0,
    office: 0,
    sale: 0,
    sorting: '',
    searchString: '',
    available: 1,
};
let params = new URL(window.location.href).searchParams;
let command = $('#filtersForm').data('ws');
window.target = '';
var clipboard = new ClipboardJS('.copy');

function submitPagination(command, obj) {
    window.spinner.show();
    const urlParams = new URLSearchParams(window.location.search);
    Object.entries(obj).forEach(([key, value]) => {
        let rewrite = false;
        if (value !== undefined) {
            if (Array.isArray(value) ? value.length > 0 : value !== "") {
                if (value !== 0) {
                    rewrite = true;
                }
            }
        }
        if (rewrite) {
            if (key === 'available' && window.paginationObj.available === 1) {
                urlParams.delete(key);
            } else {
                if (!Array.isArray(value)) {
                    urlParams.set(key, value.toString());
                } else {
                    let s = '';
                    Object.entries(value).forEach(([k, v]) => {
                        return s += v + ','
                    });
                    const last = s.charAt(s.length - 1);
                    if (last === ',') {
                        s = s.slice(0, s.length - 1);
                    }
                    urlParams.set(key, s);
                }
            }
        } else if (key === 'available' && window.paginationObj.available === 0) {
            urlParams.set(key, window.paginationObj.available);
        } else {
            urlParams.delete(key);
        }

    });
    let stateObj = {
        paginationReloadRequired: true,
    };

    let paramsString = '?' + urlParams.toString();
    if (paramsString === '?') {
        paramsString = '';
    }

    let urlString = window.location.origin + window.location.pathname + paramsString;

    if (window.location.newHref !== '' && window.location.newHref !== undefined) {
        urlString = window.location.origin + window.location.newHref + paramsString;
    }

    if (command === WsCommandEnum.SEARCH_POST) {
        let newUrl = $('form.search-form #searchSelect option:selected').val();
        if (newUrl.length > 1 && newUrl !== '0') {
            urlString = newUrl + paramsString;
        } else {
            newUrl = $('form.search-form').attr('action');
            if (newUrl.length > 1 && newUrl !== '0') {
                urlString = $('form.search-form').attr('action') + paramsString;
            }
        }
        window.location.href = urlString;
    } else if (command === WsCommandEnum.PAGINATION) {
        window.location.href = urlString;
    } else if (command === WsCommandEnum.CONFIGURATOR || command === WsCommandEnum.CONFIGURATOR_OPTIONAL) {
        if (Utils.isWebsocketReady()) {
            if (Object.keys(obj).length === 0) {
                WsRequest.customWebSocketAction({
                    query: obj, url: window.location.newHref ?? window.location.href,
                }, command);
            } else {
                WsRequest.customWebSocketAction({
                    query: Object.fromEntries(urlParams.entries()), url: window.location.newHref ?? window.location.href,
                }, command);
            }
        } else {
            window.location.href = urlString;
        }
    } else {
        window.history.pushState(stateObj, '', urlString);
        if (Utils.isWebsocketReady()) {
            WsRequest.customWebSocketAction({
                query: Object.fromEntries(urlParams.entries()), url: window.location.newHref ?? window.location.href,
            }, command);
        } else {
            window.location.href = urlString;
        }
    }
}

function filters() {
    if (changePrice()) {
        if (window.paginationObj.sorting === 'Popularność: największa') {
            window.paginationObj.sorting = '';
        }
        submitPagination(command, window.paginationObj);
        // submitPagination(WsCommandEnum.PAGINATION, window.paginationObj);
    }
}

function resetTimer() {
    if (typeof window.t !== 'undefined') {
        clearTimeout(window.t);
    }
    window.t = setTimeout(filters, 800);
}

jQuery.validator.addMethod("greaterThan", function (value, element, param) {
    let priceMax = $(param);
    let errors = {};
    this.invalid[priceMax.attr('name')] = false;
    this.hideErrors();
    priceMax.removeClass('error')

    let max = 0;
    let min = 0;

    if ($('#price_max').val() !== '') {
        max = parseInt($('#price_max').val());
    }

    if ($('#price_min').val() !== '') {
        min = parseInt($('#price_min').val());
    }

    if (min === max) {
        return true;
    }

    if (min === 0 && max === 0) {
        return true;
    }

    if (min > 0 && max === 0) {
        return true;
    }

    if (min === 0 && max > 0) {
        return true;
    }

    if (min > 0 && max > 0 && max > min) {
        return true;
    }

    this.invalid[priceMax.attr('name')] = true;

    errors[priceMax.attr('name')] = "Cena \"do\" nie może być mniejsza od ceny \"od\"";
    this.showErrors(errors);
    return false;
}, "Cena \"do\" nie może być mniejsza od ceny \"od\"");

// "min:max" dla filtra typu zakres; pusta strona zostaje pusta, przecinek dziesiętny → kropka
const composeRange = (param) => {
    const norm = (v) => {
        v = (v || '').toString().trim().replace(',', '.');
        return (v !== '' && !isNaN(v)) ? v : '';
    };
    const lo = norm($('input.f-range[data-range="min"][data-feature-param="' + param + '"]').val());
    const hi = norm($('input.f-range[data-range="max"][data-feature-param="' + param + '"]').val());
    return (lo !== '' || hi !== '') ? lo + ':' + hi : '';
};

// Wartość pola ceny w postaci, w jakiej trafia do paginationObj. Pola startują wypełnione
// granicami listy (data-bound), więc wartość równa granicy znaczy "bez ograniczenia" -
// dokładnie tak samo jak pole puste. Bez data-bound zachowanie jest jak dawniej.
const priceFieldValue = ($field) => {
    const raw = $field.val();
    if (raw === '' || isNaN(raw)) {
        return 0;
    }

    const value = parseInt(raw, 10);
    const bound = parseInt($field.data('bound'), 10);

    return (!isNaN(bound) && value === bound) ? 0 : value;
};

// Suwak dwuuchwytowy. Uchwyty tylko wpisują wartości w istniejące pola "od"/"do" -
// filtrowanie idzie tą samą drogą co wpisanie ich ręcznie. onChange dostaje sam moment
// puszczenia uchwytu, bo porównanie z paginationObj wygląda inaczej dla cech i dla ceny.
// blankAtEdges: przy cechach uchwyt na krawędzi czyści pole, przy cenie wpisuje granicę,
// bo tam pola mają być widocznie wypełnione.
const bindRangeSlider = ($slider, $min, $max, lo, hi, onChange, blankAtEdges = true) => {
    // całkowite granice → krok 1, ułamkowe → setna część zakresu
    const step = (Number.isInteger(lo) && Number.isInteger(hi)) ? 1 : (hi - lo) / 100;
    const toValue = (raw, fallback) => {
        const v = parseFloat((raw || '').toString().trim().replace(',', '.'));
        return isNaN(v) ? fallback : Math.min(Math.max(v, lo), hi);
    };
    const format = (v) => Number.isInteger(step) ? Math.round(v).toString() : parseFloat(v.toFixed(3)).toString();

    // przepisanie wartości z pól na uchwyty nie może udawać ruchu użytkownika
    let syncing = false;

    $slider.slider({
        range: true,
        min: lo,
        max: hi,
        step: step,
        values: [toValue($min.val(), lo), toValue($max.val(), hi)],
        slide: (event, ui) => {
            // uchwyt na samej krawędzi = brak ograniczenia
            $min.val(blankAtEdges && ui.values[0] <= lo ? '' : format(ui.values[0]));
            $max.val(blankAtEdges && ui.values[1] >= hi ? '' : format(ui.values[1]));
        },
        change: () => {
            if (syncing) {
                return;
            }
            onChange();
        }
    });

    $min.add($max).on('focusout keyup', () => {
        syncing = true;
        $slider.slider('values', [toValue($min.val(), lo), toValue($max.val(), hi)]);
        syncing = false;
    });
};

// Suwaki cech typu zakres
const initFeatureRangeSliders = () => {
    if (typeof $.fn.slider !== 'function') {
        return;
    }

    $('.f-range-slider').not('.price-slider').each(function () {
        const $slider = $(this);
        if ($slider.hasClass('ui-slider')) {
            return;
        }

        // pola z tego samego bloku, nie po data-feature-param - ten sam filtr bywa
        // wyrenderowany dwa razy (widok zwykły i tabletowy)
        const $block = $slider.closest('.feature-range');
        const $min = $block.find('input.f-range[data-range="min"]');
        const $max = $block.find('input.f-range[data-range="max"]');
        const param = $slider.data('featureParam');
        const lo = parseFloat($slider.data('rangeMin'));
        const hi = parseFloat($slider.data('rangeMax'));

        if ($min.length === 0 || $max.length === 0 || isNaN(lo) || isNaN(hi) || hi <= lo) {
            return;
        }

        bindRangeSlider($slider, $min, $max, lo, hi, () => {
            if (composeRange(param) !== (window.paginationObj[param] || '')) {
                // po przeciągnięciu nie ma czego fokusować, a stare id wysypałoby setSelectionRange
                window.target = '';
                resetTimer();
            }
        });
    });
};

// Suwak filtra ceny - pisze w te same pola #price_min / #price_max, w których zwykle
// wpisuje się kwoty ręcznie. Puste pole = brak ograniczenia, czyli 0 w paginationObj.
const initPriceRangeSlider = () => {
    if (typeof $.fn.slider !== 'function') {
        return;
    }

    $('.price-slider').each(function () {
        const $slider = $(this);
        if ($slider.hasClass('ui-slider')) {
            return;
        }

        const $block = $slider.closest('.price-range');
        const $min = $block.find('#price_min');
        const $max = $block.find('#price_max');
        // maska pól ceny przepuszcza tylko całe złotówki, więc i granice są całkowite
        const lo = parseInt($slider.data('rangeMin'), 10);
        const hi = parseInt($slider.data('rangeMax'), 10);

        if ($min.length === 0 || $max.length === 0 || isNaN(lo) || isNaN(hi) || hi <= lo) {
            return;
        }

        // awaryjnie, gdyby widok nie wypełnił pól granicami - pusto albo 0 to nie jest
        // wartość, którą da się pokazać na uchwycie
        $min.add($max).each(function () {
            const $field = $(this);
            const bound = parseInt($field.data('bound'), 10);
            if (emptyToInt($field.val()) === 0 && !isNaN(bound)) {
                $field.val(bound);
            }
        });

        bindRangeSlider($slider, $min, $max, lo, hi, () => {
            if (priceFieldValue($min) !== emptyToInt(window.paginationObj.price_min)
                || priceFieldValue($max) !== emptyToInt(window.paginationObj.price_max)) {
                window.target = '';
                if ($('#price_max').valid()) {
                    resetTimer();
                }
            }
        }, false);
    });
};

const changePrice = () => {
    window.paginationObj.price_min = priceFieldValue($('#price_min'));
    window.paginationObj.price_max = priceFieldValue($('#price_max'));

    if (params.get('sm') === null) {
        window.paginationObj.producer = [];
    }
    $('input.f-0').each(function (i, e) {
        if (!$(e).hasClass('f-1')) {
            window.paginationObj[$(e).attr('name')] = [];
        }
    });

    $('input.f-0').each(function (i, e) {
        let name = $(this).attr('name');
        if ($(this).prop('checked')) {
            window.paginationObj[name].push($(e).val());
        }
    });

    $('input.f-range[data-range="min"]').each(function (i, e) {
        const param = $(e).data('featureParam');
        window.paginationObj[param] = composeRange(param);
    });

    $(window.paginationObj).each(function (i, e) {
        if (e.length === 0) {
            window.paginationObj[e] = '';
        }
    });

    if ($('#sortSelect').length > 0) {
        window.paginationObj.sorting = $('#sortSelect option:selected').val();
    } else {
        window.paginationObj.sorting = '';
    }

    if ($('#office').length > 0) {
        window.paginationObj.office = $('#office option:selected').val();
    } else {
        window.paginationObj.office = '';
    }

    if ($('#search').length > 0) {
        window.paginationObj.searchString = $('#search').val();
    } else {
        window.paginationObj.searchString = '';
    }

    $('.categoryFilters ul li a').each(function (i, e) {
        if ($(e).hasClass('current')) {
        }
    });

    if (parseInt(window.paginationObj.page) === 1) {
        window.paginationObj.page = 0;
    }

    return true;
}

// rozwinięte przez klienta grupy filtra „Grupy” (id listy wartości) — przeżywają przerysowanie filtrów
window.openFeatureGroups = window.openFeatureGroups || {};

function bind() {
    changePrice();
    initFeatureRangeSliders();
    initPriceRangeSlider();

    command = $('#filtersForm').data('ws');

    const productContainer = $('.product-list-container');

    if (productContainer.length > 0) {
        window.onpopstate = function (e) {
            if (e || e.state && e.state.paginationReloadRequired) {
                location.reload();
            }
        }
    }

    $("#filtersForm").validate({
        rules: {
            price_max: {
                greaterThan: "#price_max",
            },
        },
        errorPlacement: function (error, element) {
            const container = element.parents().eq(1);
            error.appendTo(container);
        },
    });

    $('[data-pl-pagination="input"]').on('mouseenter', function (e) {
        $(this).attr('placeholder', 'nr');
    });
    $('[data-pl-pagination="input"]').on('mouseleave', function (e) {
        $(this).attr('placeholder', '\u2026');
    });

    $('[data-pl-pagination="change"]').on('click', function (e) {
        if (Utils.isWebsocketReady()) {
            e.stopPropagation();
            e.preventDefault();
        }
        window.paginationObj.page = $(this).data('plPage');
        filters();
        $([document.documentElement, document.body]).animate({
            scrollTop: $('#category-name').offset().top - 70
        }, { duration: 200 });
    });

    $('[data-pl-pagination="input"]').on('focusin', function () {
        $(this).on('keypress', function (e) {
            if (e.key === 'Enter') {
                window.paginationObj.page = $(this).val();
                filters();
            }
        });
    });

    $('[data-pl-pagination="input"]').on('focusout', function () {
        $(this).off('keypress');
        window.paginationObj.page = $(this).val();
        filters();
    });

    $('input.f-1').on('focusout', function (e) {
        let value = priceFieldValue($(this));
        if (value !== parseInt(window.paginationObj[$(this).attr('name')])) {
            window.target = $(this).attr('id');
            if ($('#price_max').valid()) {
                resetTimer();
            }
        }
    });

    $('input.f-1').on('keyup', function (e) {
        let value = priceFieldValue($(this));
        if ((e.keyCode >= 96 && e.keyCode <= 105) ||
            (e.keyCode >= 48 && e.keyCode <= 57) ||
            e.keyCode === 8 || e.keyCode === 46
            && value !== parseInt(window.paginationObj[$(this).attr('name')])) {
            window.target = $(this).attr('id');
            if ($('#price_max').valid()) {
                resetTimer();
            }
        }
    });

    $('input.f-0').on('click', function () {
        if (!$(this).hasClass('f-1')) {
            if ($('#price_max').valid()) {
                resetTimer();
            }
        }
    });

    // filtr „Grupy”: checkbox grupy zaznacza/odznacza jej wartości — do adresu idą same wartości
    $('input.f-group').each(function () {
        if ($(this).data('partial')) {
            $(this).prop('indeterminate', true);
        }
    }).on('click', function () {
        $(this).closest('.feature-group').find('.feature-group-values input.f-0').prop('checked', $(this).prop('checked'));
        if ($('#price_max').valid()) {
            resetTimer();
        }
    });

    $('input.f-0').on('click', function () {
        const group = $(this).closest('.feature-group');
        if (group.length) {
            const boxes = group.find('.feature-group-values input.f-0');
            const checked = boxes.filter(':checked').length;
            group.find('input.f-group').prop({checked: checked === boxes.length, indeterminate: checked > 0 && checked < boxes.length});
        }
    });

    $('.feature-group-toggle').on('click', function () {
        const open = $(this).attr('aria-expanded') !== 'true';
        $(this).attr('aria-expanded', open ? 'true' : 'false');
        $('#' + $(this).attr('aria-controls')).toggleClass('d-none', !open);
        if (open) {
            window.openFeatureGroups[$(this).attr('aria-controls')] = true;
        } else {
            delete window.openFeatureGroups[$(this).attr('aria-controls')];
        }
    });
    // filtry przerysowują się po każdej zmianie — przywracamy grupy rozwinięte przez klienta
    Object.keys(window.openFeatureGroups).forEach(function (id) {
        $('#' + id).removeClass('d-none');
        $('.feature-group-toggle[aria-controls="' + id + '"]').attr('aria-expanded', 'true');
    });

    $('input.f-range').on('focusout', function () {
        const param = $(this).data('featureParam');
        if (composeRange(param) !== (window.paginationObj[param] || '')) {
            window.target = $(this).attr('id');
            resetTimer();
        }
    });

    $('input.f-range').on('keyup', function (e) {
        if ((e.keyCode >= 96 && e.keyCode <= 105) ||
            (e.keyCode >= 48 && e.keyCode <= 57) ||
            e.keyCode === 8 || e.keyCode === 46) {
            const param = $(this).data('featureParam');
            if (composeRange(param) !== (window.paginationObj[param] || '')) {
                window.target = $(this).attr('id');
                resetTimer();
            }
        }
    });

    $('input.available').on('click', function () {
        if ($(this).is(':checked')) {
            window.paginationObj.available = 1;
        } else {
            window.paginationObj.available = 0;
        }

        submitPagination(command, window.paginationObj);
    });

    if (window.target !== '') {
        $('#' + window.target).trigger('focus');
        let t = document.getElementById(window.target);
        t.setSelectionRange($('#' + window.target).val().length * 2, $('#' + window.target).val().length * 2);
    }

    $("a.showAll").on('click', function (e) {
        e.preventDefault();
        $(this).closest(".tablet-basket-options").find(".d-none").toggleClass("d-block");
    });

    // sorting list action
    $("#sortSelect, #office").on('change', function () {
        filters();
    });

    $('.filter.choose-opt-sort').on('click', function () {
        $(".mobile-product-sort .tablet-basket-options-container.choose-opt-sort").fadeIn(0);
    });

    $(".mobile-product-sort .tablet-basket-options-container input[type=radio]").on('click', function (e) {
        $('#sortSelect').val($(this).val()).trigger('change');
    });

    $('ul.categoryFilters li a').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearData();
        window.location.newHref = '';
        if ($(this).hasClass('current')) {
            $(this).toggleClass('current');
        } else {
            categoryClear();
            $(this).toggleClass('current');
        }
        window.location.newHref = $(this).attr('href');
        filters();
    });

    $('.owl-prod-list-cat .owl-item .cat-link').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearData();

        // return false;
        window.location.newHref = '';
        if ($(this).hasClass('current')) {
            $(this).toggleClass('current');
        } else {
            categoryClear();
            $(this).toggleClass('current');
        }
        window.location.newHref = $(this).attr('href');
        filters();
    });

    $('.clearFilters').on('click', function (e) {
        e.preventDefault();
        clearPagination();
    });

    producersFilterDisplay();
}

const producersFilterDisplay = () => {
    let max = 6;
    if ($('.producersFilter ul').data('max') !== undefined) {
        max = parseInt($('.producersFilter ul').data('max'));
    }
    let count = 0;
    let checked = [];
    let unchecked = [];
    $('.producersFilter').find('input.f-0').each(function (i, e) {
        if ($(e).is(':checked')) {
            checked.push(e);
        } else {
            unchecked.push(e);
        }
        ++count;
    });
    if (count > max) {
        let c = checked.length;
        let border = max - c;
        if (c === 0) {
            $('.producersFilter').find('input.f-0').each(function (i, e) {
                if (i > max) {
                    $(e).closest('li').addClass('d-none');
                }
            });
        }
        if (c < max && c > 0) {
            unchecked.forEach(function (e, i) {
                if (i < border || i === max) {
                    checked.unshift(unchecked[0]);
                    unchecked.shift();
                }
            });
            unchecked.forEach(function (e, i) {
                $(e).closest('li').addClass('d-none');
            });
        }
        if (c >= max) {
            unchecked.forEach(function (e, i) {
                $(e).closest('li').addClass('d-none');
            });
        }
    }

    $("a.showAll").on('click', function (e) {
        e.preventDefault();
        const text = $(this).text();
        if (text === "Pokaż więcej") {
            $(this).text("Pokaż mniej");
        } else {
            $(this).text("Pokaż więcej");
        }
    });
};

const categoryClear = () => {
    $('.categoryFilters ul li a').each(function (i, e) {
        if ($(e).hasClass('current')) {
            $(e).removeClass('current');
        }
    });
};

const clearPagination = () => {
    clearData();
    categoryClear();
    submitPagination(command, window.paginationObj);
};

const emptyToInt = (value) => {
    if (value === '' || value === NaN || value === undefined) {
        value = 0;
    } else {
        value = parseInt(value);
    }
    return value;
};

function openFilterBtn() {
    $(".choose-opt").on('click', function (e) {
        e.preventDefault();
        $("#left-sub-menu").toggleClass('d-none');
        if (!$("#right-sub-menu").hasClass('d-none')) {
            $("#right-sub-menu").toggleClass('d-none');
        }
    });

    $(".choose-opt-pay").on('click', function (e) {
        e.preventDefault()
        $("#right-sub-menu").toggleClass('d-none');
        if (!$("#left-sub-menu").hasClass('d-none')) {
            $("#left-sub-menu").toggleClass('d-none');
        }
    });

    $(".close-sorting-btn").on('click', function (e) {
        e.preventDefault();
        $("#right-sub-menu").toggleClass('d-none');
    });
}

function closeFilterBtn() {
    $(".close-categories-btn").on('click', function (e) {
        e.preventDefault();
        $("#left-sub-menu").toggleClass('d-none');
    })
}

const clearData = () => {

    window.target = '';
    window.paginationObj.page = 0;

    window.paginationObj.price_min = 0;
    window.paginationObj.price_max = 0;
    window.paginationObj.sorting = '';
    window.paginationObj.available = 1;
    window.paginationObj.sale = 0;

    $('input.f-0:checked').each(function (i, e) {
        if ($(e).attr('name') !== 'producer') {
            $(e).prop('checked', false);
            $(e).removeAttr('checked');
            window.paginationObj[$(e).attr('name')] = [];
        }
    });

    $('input.f-range').each(function (i, e) {
        $(e).val('');
        window.paginationObj[$(e).data('featureParam')] = '';
    });

    // pola ceny wracają do granic listy, czyli do stanu "bez ograniczenia" - i robimy to
    // przed suwakami, inaczej reset uchwytów zobaczyłby stare kwoty i odpalił kolejne
    // zapytanie w trakcie czyszczenia filtrów
    $('#price_min, #price_max').each(function (i, e) {
        const bound = parseInt($(e).data('bound'), 10);
        $(e).val(isNaN(bound) ? '' : bound);
    });

    $('.f-range-slider.ui-slider').each(function (i, e) {
        const $s = $(e);
        $s.slider('values', [$s.slider('option', 'min'), $s.slider('option', 'max')]);
    });

    if (params.get('sm') === null) {
        $('input[name="producer"]:checked').each(function (i, e) {
            $(e).prop('checked', false);
            $(e).removeAttr('checked');
        });
        window.paginationObj.producer = [];
    }
};

$(function () {
    $('form.search-form').on('submit', function (e) {
        e.preventDefault();
        command = 'search-post';
        window.paginationObj = {
            page: 0,
            producer: [],
            price_min: 0,
            price_max: 0,
            sorting: '',
            searchString: $(this).find('input').val(),
        };
        submitPagination(command, window.paginationObj);
    });
});

export {
    bind,
    clearPagination,
    submitPagination,
    openFilterBtn,
    closeFilterBtn
}
